// extracted by mini-css-extract-plugin
export default {"upgradeGroup":"upgrade-group_upgradeGroup__J0ODj"};